<template>
  <validation-observer
    v-if="!isOccupiedByPolicyholderOnly"
    v-slot="propertyOccupiedByObserver"
    slim
  >
    <form-section
      id="property-occupied-by"
      v-bind="propertyOccupiedByObserver"
      :validated="formObserver.validated"
    >
      <!--  PROPERTY ADULTS  -->
      <form-row
        label="How many adults live in the property?"
        :error="formObserver.validated && !propertyOccupiedByObserver.valid"
      >
        <validation-provider
          name="Property Adults"
          :vid="`${stepId}_property-adults`"
          rules="required|numeric|between:1,6"
          slim
        >
          <quantity
            v-model.number="propertyAdults"
            :max="6"
            data-test="property_adults"
            max-with-plus
            @max-limit="onPersonsLimitExceed('adults')"
          />
        </validation-provider>
      </form-row>

      <help-text
        :error="formObserver.validated && !propertyOccupiedByObserver.valid"
        class="mb-4"
      >
        <p>If this is a shared property, please indicate how many adults live in the house regardless if they are on the policy or not.</p>
      </help-text>

      <!--  PROPERTY CHILDREN  -->
      <form-row
        label="How many children live in the property?"
        :error="formObserver.validated && !propertyOccupiedByObserver.valid"
      >
        <validation-provider
          name="Property Children"
          :vid="`${stepId}_property-children`"
          rules="required|numeric|between:0,6"
          slim
        >
          <quantity
            v-model.number="propertyChildren"
            :max="6"
            data-test="property_children"
            max-with-plus
            @max-limit="onPersonsLimitExceed('children')"
          />
        </validation-provider>
      </form-row>

      <help-text
        :error="formObserver.validated && !propertyOccupiedByObserver.valid"
      >
        <p>Please tell us the number of people living there under the age of 18.</p>
      </help-text>

      <validation-provider
        v-slot="{ failed, errors }"
        :vid="`${stepId}_occupied-by`"
        name="Property Occupied By"
        :rules="occupiedByRules"
        immediate
      >
        <input
          :value="occupiedBy"
          type="hidden"
        >
        <div
          v-if="formObserver.validated && failed"
          class="error--text mt-4 fz12"
        >
          {{ errors[0] }}
        </div>
      </validation-provider>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

export default {
  name: 'question-property-occupied-by',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyAdults', 'propertyChildren'],
    };
  },
  computed: {
    isOccupiedByPolicyholderOnly () {
      return this.stepData.propertyOccupied === 'P';
    },

    propertyAdults: {
      get () {
        return this.questionData.propertyAdults;
      },
      set (val) {
        this.questionData.propertyAdults = val >= 6 ? 6 : val;
      },
    },

    propertyChildren: {
      get () {
        return this.questionData.propertyChildren;
      },
      set (val) {
        this.questionData.propertyChildren = val >= 6 ? 6 : val;
      },
    },

    occupiedBy () {
      return {
        adults: this.questionData.propertyAdults,
        children: this.questionData.propertyChildren,
      };
    },

    occupiedByRules () {
      if (this.isOccupiedByPolicyholderOnly) return '';

      return {
        propertyOccupiedBy: {
          occupiedOption: this.stepData.propertyOccupied,
        },
      };
    },
  },
  watch: {
    'stepData.propertyOccupied' (val) {
      if (val && this.isOccupiedByPolicyholderOnly) {
        this.questionData.propertyAdults = 1;
        this.questionData.propertyChildren = 0;
      }
    },
  },
  methods: {
    onPersonsLimitExceed (personType) {
      this.$emit('toast', {
        type: 'info',
        text: `Please note: the maximum number of ${personType} here is 6+`,
      });
    },
  },
};
</script>
